import { call, delay, put } from 'redux-saga/effects';
import moment from 'moment';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE, LOADING_DELAY } from '../../../configs';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import processError from '../../../utils/processError';
import { loadHostStatusesHistoryBegin, loadHostStatusesHistoryFailed, loadHostStatusesHistorySuccessful } from '../actions';

export default function* loadHostStatusesHistory(action) {
  try {
    const {
      payload: {
        page = 1,
        limit = DEFAULT_ITEMS_OF_PAGE,
        filter: filterData,
        metricKeys = null,
      } = {},
    } = action;
    const url = `${BACKEND_URL}/host-statuses/history`;
    const filter = { ...filterData };
    filter.type = 1;
    const pool = {
      page,
      limit,
    };
    if (metricKeys) {
      pool.select_metric_keys = metricKeys;
    }
    if (filter && Object.keys(filter).length) {
      pool.filter = filter;
    }
    yield delay(LOADING_DELAY);
    yield put(loadHostStatusesHistoryBegin());
    const dataResponse = yield makeRequest(url, pool, action, 'POST', true);
    const data = yield dataResponse.json();
    if (dataResponse.status === OK) {
      yield put(loadHostStatusesHistorySuccessful(data));
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadHostStatusesHistoryFailed());
      yield call(rejectActionPromise(action, data));
    }
  } catch (e) {
    yield put(loadHostStatusesHistoryFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
